import { Layout } from "@kursk/components/Layout/Layout";
import { Banner } from "@kursk/components/pages/PushkinCard/Banner/Banner";
import { InfoBlock } from "@kursk/components/pages/PushkinCard/InfoBlock/InfoBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { EventsGrid } from "@kursk/components/pages/PushkinCard/EventsGrid/EventsGrid";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { useOrientations } from "@common/hooks/useOrientation";
import { picksSlice } from "@common/redux/slices/picks";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import styles from './PushkinCard.module.scss';


const INFO_BANNERS = [
  {
    type: 'image',
    src: {
      desktop: 'images/what-is.svg',
      tablet: 'images/what-is-mobile.svg',
      mobile: 'images/what-is-mobile.svg',
    },
  },
  {
    type: 'withButtons',
    src: {
      desktop: 'images/how-to-get.svg',
      tablet: 'images/how-to-get-mobile.svg',
      mobile: 'images/how-to-get-mobile.svg',
    },
    srcButtons: [
      {
        src: 'images/app-store.svg',
        link: 'https://apps.apple.com/ru/app/id1581979387'
      },
      {
        src: 'images/google.svg',
        link: 'https://play.google.com/store/apps/details?id=ru.gosuslugi.culture'
      }
    ]
  },
  {
    type: 'image',
    src: {
      desktop: 'images/how-to-spend.svg',
      tablet: 'images/how-to-spend-mobile.svg',
      mobile: 'images/how-to-spend-mobile.svg',
    },
  },
  {
    type: 'image',
    src: {
      desktop: 'images/how-to-buy.svg',
      tablet: 'images/how-to-buy-mobile.svg',
      mobile: 'images/how-to-buy-mobile.svg',
    },
  },
  {
    type: 'image',
    src: {
      desktop: 'images/return.svg',
      tablet: 'images/return-mobile.svg',
      mobile: 'images/return-mobile.svg',
    },
    link: '/faq'
  },
  {
    type: 'image',
    src: {
      desktop: 'images/else-to-know.svg',
      tablet: 'images/else-to-know-mobile.svg',
      mobile: 'images/else-to-know-mobile.svg',
    },
  }
]

export interface ISrc {
  desktop: string,
  tablet: string,
  mobile: string,
}

export interface ISrcButtons {
  src: string,
  link: string
}

export interface IInfoBanner {
  type: string,
  src?: ISrc,
  srcButtons?: ISrcButtons[],
  link?: string
}

export const PushkinCard = () => {

  const { forPushkinPlaces } = useSelectSlice(recommendationSlice);
  const { topPushkinEvents } = useSelectSlice(picksSlice);

  const events = topPushkinEvents
    .map(element => element.pushkinEvent)
    /** Фильтруем из выдачи сущности, у которых нет картинки и названия, чтобы страница не падала **/
    .filter(event => !!(event.name && event.image));

  const orientation = useOrientations();

  return (
    <Layout>
      <SeoMetaTitles page="pushkincard" titleOg="Пушкинская карта"/>
      <section className={styles.banners}>
        <Banner/>
        <div className={styles.socials}>
          <SocialLinks/>
        </div>
        <InfoBlock elements={INFO_BANNERS}/>
        {(events.length > 0 && orientation === "desktop") ?
          <EventsGrid pushkinPage events={events} /> :
          <div className={styles.section}>
            <RecommendationsBlock
              entityType="events"
              data={events}
              title={'Афиша Пушкинской Карты'}
              goTo={'/events/tag-pushkinskaya-karta'}
              goToTitle={orientation === 'mobile' ? 'все' : 'показать все'}
              pushkinPage
              theme='white'
            />
          </div>
        }
        {forPushkinPlaces && (
          <div className={styles.section}>
            <RecommendationsBlock
              entityType="places"
              data={forPushkinPlaces}
              title={'Участники Программы'}
              goTo={'/places'}/>
          </div>
        )}
      </section>
    </Layout>
  );
}
